export const UPDATE_ACTIVE_VARIANT = 'buying-panel:update-active-variant'
export const UPDATE_GIFT_MESSAGE = 'buying-panel:update-gift-message'
export const SET_REQUIRE_GIFT_MESSAGE = 'buying-panel:set-require-gift-message'
export const SET_ACTIVE_BUYING_OPTIONS =
  'buying-panel:set-active-buying-options'
export const RESET_ACTIVE_VARIANT = 'buying-panel:reset-active-variant'
export const TRIGGER_GIFT_MESSAGE_CHECKING =
  'buying-panel:trigger-gift-message-checking'
